import React from 'react';
//import './YourStyleSheet.css'; // Replace with your actual stylesheet path

const ApplyForGrantSection = () => {
    return (
        <div className="container" id="grants">
            <p></p>
            <div className="section-title">
                <small>GRANTS</small>
                <h3 className="h3-purple">Types of Grant</h3>
            </div>


        <div className="paul-cards-container">
                
                <div className="paul-card">
        
                        <div className="paul-card-head-top-part-of-card">  
                        <br></br>
                            <div className="paul-pink-text paul-font-size-40pc" >SCHOOLS</div>
                                
                         
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Install fountain in a school</div>
                            <div className="paul-list-group-item">School fountain model</div>
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/school-pack-pdf-2026.pdf" className="btn btn-primary btn-lg btn-block">Apply for Schools Grant</a>
                        </div>
                </div>

      <div className="paul-card">
        <div className="paul-card-head-top-part-of-card">  
            <br></br>
            <div className="paul-pink-text paul-font-size-40pc" >OVERSEAS</div>          
           
                       
        </div>

                <ul className="list-group list-group-flush">
                    <div className="paul-list-group-item">Install fountain outside the UK</div>
                    <div className="paul-list-group-item">Apply for an overseas grant</div>
                </ul>
                
                <div className="paul-card-padding-around-button">
                   <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/new%20grant-application%20(Overseas)2026.pdf" className="btn btn-primary btn-lg btn-block">Apply for Non-UK Grant</a>
                </div>
      </div>

      <div className="paul-card">
                        <div className="paul-card-head-top-part-of-card">
                        <br></br>
                            <div className="paul-pink-text paul-font-size-40pc" >UK</div>
                          
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Install fountain in the UK (non-school)</div>
                            <div className="paul-list-group-item">Apply for a grant to install a fountain in the UK</div>
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/new-grant-application-pdf-2026.pdf" className="btn btn-primary btn-lg btn-block">Apply for UK Grant</a>
                        </div>
                </div>
      <div className="paul-card">
                        <div className="paul-card-head-top-part-of-card">   
                             <br></br>
                            <div className="paul-pink-text paul-font-size-40pc" >RESTORATION</div>          
            
                          
                        </div>

                        <ul className="list-group list-group-flush">
                            <div className="paul-list-group-item">Restore an existing fountain</div>
                            <div className="paul-list-group-item">Apply for a grant to restore an existing fountain</div>
                        </ul>
                        
                        <div className="paul-card-padding-around-button">
                            <a href="https://public-dfa-forms.s3.eu-west-2.amazonaws.com/new%20grant-application%20(Restoration)2026.pdf" className="btn btn-primary btn-lg btn-block">Apply for Restoration Grant</a>
                        </div>
                </div>
        </div>

           
    </div>
    );
};

export default ApplyForGrantSection;
